/**
 * Turns a base64 data URL (what react-webcam's getScreenshot returns) into a
 * File, decoding it in place.
 *
 * Not `fetch(dataUrl)`: production's CSP has `connect-src 'self'`, which
 * blocks a fetch of a data: URL.
 */
export function dataUrlToFile(dataUrl: string, filename: string): File {
  const match = /^data:([^;,]+)?(;base64)?,(.*)$/s.exec(dataUrl);
  const payload = match?.[3];
  if (!match || !match[2] || payload === undefined) {
    throw new Error("Not a base64 data URL");
  }
  const mime = match[1] || "image/jpeg";
  const binary = atob(payload);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new File([bytes], filename, { type: mime });
}
